
export function ProductHeroSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                AI-Powered Cybersecurity Built for UK SMEs
              </h1>
              <p className="text-xl text-gray-400 mb-8 leading-relaxed">
                Driscop is developing an advanced AI platform that will combine threat detection, real-time training, and unified security management specifically for UK small and medium-sized enterprises.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <button className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-rocket-line mr-2"></i>
                  Join Beta Program
                </button>
                <button className="border border-blue-400 text-blue-400 px-8 py-4 rounded-lg text-lg font-medium hover:bg-blue-500/100/200/10 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-play-line mr-2"></i>
                  Preview Concept
                </button>
              </div>

              <div className="grid grid-cols-3 gap-6 text-center">
                <div>
                  <div className="text-2xl font-bold text-blue-400 mb-1">99.7%</div>
                  <div className="text-sm text-gray-400">Detection Rate</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-blue-400 mb-1">&lt;5min</div>
                  <div className="text-sm text-gray-400">Setup Time</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-blue-400 mb-1">24/7</div>
                  <div className="text-sm text-gray-400">Protection</div>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=600&h=500&fit=crop&crop=center"
                alt="Driscop cybersecurity platform interface"
                className="w-full h-auto rounded-xl shadow-lg object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
